import instaclustrComponent from "./Components";
import layoutResizing from "../utils/layoutResizing";
import progressBar from "../utils/progressBar";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth = viewport().width;

        let $formId   = $('#formId').attr('data-info'),
            $gaEvent  = $('#gaEvent').attr('data-info'),
            $driftId  = $("#driftId").attr('data-info'),
            $redirect = $('#followUpUrl').attr('data-info');

        let $driftIdNum = Number($driftId);

        let $formDesktop        = $('.form-container.form-desktop'),
            $formMobile         = $('.form-container.form-mobile'),
            $formElement = '<form id="mktoForm_' + $formId + '"></form>';

        // Load form separately in desktop and mobile containers
        if (vpWidth > 768) {
            $formDesktop.append($formElement);
        } else {
            $formMobile.append($formElement);
        }
        const loadForm = () => {
            MktoForms2.loadForm("//go.digital.netapp.com", "683-HWH-936", $formId, function (form) {
                form.onSuccess((values) => {
                    if ($gaEvent) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': $gaEvent
                        });
                    }
                    if ($driftId) {
                        drift.api.collectFormData(values, {
                            campaignId: $driftIdNum,
                            followupUrl: $redirect
                        });
                        return false;
                    } else {
                       if ($redirect) {
                           window.location = $redirect;
                       }
                    }
                });
            });
        }

        const labelAnimations = () => {
            let $form   = $('.mktoForm');
            let $inputs = $form.find('input');
            $inputs.each(function() {
                let $this = $(this);
                $this.focusin(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
                $this.focusout(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
            })
        }

        // Check if the forms2.min.js script is loaded
        if (window.MktoForms2) {
            try {

                // Load form
                loadForm();

                MktoForms2.whenReady(function() {
                    // Hide loading gif
                    $('#loadingGif').hide();

                    // Resizes component height based on form height
                    let $form            = $('.component.component-form-hero-two-column-2024 .form-content .form-content-container');
                    let $hero            = $('.hero-background-container');
                    let $supportingCards = $('.component-supporting-cards');
                    let $formHeight      = $form[0].offsetHeight;
                    let $heroHeight      = $hero[0].offsetHeight;
                    if (vpWidth > md) {
                        // +200: 100 for the form offset from top, 100 for breathing room on bottom
                        $supportingCards.css({'height' : $formHeight - $heroHeight + 200 + 'px' });
                    }

                    labelAnimations();
                    progressBar('hero');
                });
            } catch (a) {
                console.log(a);
            }
        }

        // Adjust layout after window resize
        layoutResizing();

    }
}